import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';

// Hooks
import { handleLaunchExternalLink } from 'Shared/utils/external-link';

// API
import { getUserBySlug } from 'Shared/api/user';

// Images
import checkEmailUrl from './check_email.png';
import GoogleLogo from 'Shared/images/google-logo.svg';
import Office365Logo from 'Shared/images/office365-logo.svg';

// Components
import { WpButtonGroup, WpButton } from 'Wpds/components/button';
import Spinner from 'Shared/components/Spinner';

// Styles
import './SignupCheckEmail.scss';

// Hooks
import { useApp } from 'Shared/utils/hooks/use-app';

type Props = {
  title?: string;
  customMessage?: string;
  hideResend?: boolean;
  resendEmailUrl?: string;
};

function SignupCheckEmail({
  title = 'Check Your Email',
  customMessage = '',
  hideResend = false,
  resendEmailUrl = '',
}: Props) {
  const [email, setEmail] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const {
    app: {
      routes: { resendConfirmationUrl },
    },
  } = useApp();

  const { slug } = useParams();

  useEffect(() => {
    async function getShouldConfirmedEmail() {
      setIsLoading(true);
      try {
        const response = await getUserBySlug(slug);
        if (response && response.status === 200) setEmail(response.data.user.email);
        // eslint-disable-next-line no-empty
      } catch (e) {
      } finally {
        setIsLoading(false);
      }
    }
    if (slug) getShouldConfirmedEmail();
    else setIsLoading(false);
  }, []);

  const handleGmailClick = () => {
    handleLaunchExternalLink({ href: 'https://mail.google.com/mail/u/0/' });
  };

  const handleOutlookClick = () => {
    handleLaunchExternalLink({ href: 'https://outlook.live.com/mail/0/inbox' });
  };

  const emailSentence = email ? `to ${email}` : '';
  const emailMessage = `We sent a link ${emailSentence} to verify your email.`;

  const baseClassName = 'SignupCheckEmail';
  return (
    <div className={baseClassName}>
      {isLoading ? (
        <Spinner activeIf />
      ) : (
        <>
          <h3 className={`${baseClassName}__title`}>{title}</h3>
          <p>{customMessage ? customMessage : emailMessage}</p>
          <div className={`${baseClassName}__img`}>
            <img src={checkEmailUrl} alt={checkEmailUrl} width="142" />
          </div>
          <p>If you don’t see it within a few minutes, be sure to check your spam folders!</p>
          {!hideResend && (
            <p>
              Can’t find the email? <a href={resendEmailUrl ? resendEmailUrl : resendConfirmationUrl}>Resend</a>
            </p>
          )}
          <div className={`${baseClassName}__buttons`}>
            <WpButtonGroup>
              <WpButton color="gray" block variant="secondary" size="lg" onClick={handleGmailClick}>
                <img src={GoogleLogo} className={`${baseClassName}__logo-img`} />
                Open Gmail
              </WpButton>
              <WpButton color="gray" block variant="secondary" size="lg" onClick={handleOutlookClick}>
                <img src={Office365Logo} className={`${baseClassName}__logo-img`} />
                Open Outlook
              </WpButton>
            </WpButtonGroup>
          </div>
        </>
      )}
    </div>
  );
}

export default SignupCheckEmail;
